import { Component, Fragment } from 'react';
import { steps } from '../../constants/mandate';
import styles from '../../styles/mandate.scss';
import cx from 'classnames';
import Loader from '../../components/ui/Loader';
import Button from '../../components/ui/button';
import Step from './steps';

interface Props {
  userBankDetails: any;
  downloadForm: () => void;
  downloadingForm: boolean;
  uploadButtonClick: () => void;
  handleUpload: (e: any) => void;
  authorizing: boolean;
  uploadingFile: boolean;
  fileName: string;
  handleBack: () => void;
  handleMandateAuthorize: () => void;
  fileType: string;
}

class Nach extends Component<Props> {
  public getChildren = (i: number) => {
    const { userBankDetails, downloadForm, downloadingForm } = this.props;
    const { accountNo, nameOfBank } = userBankDetails;
    if (i === 0) {
      return (
        <div>
          <div className={cx(styles['bank-details'], 'mt10')}>
            <p className="text--md font--dark-grey">Bank account details</p>
            <p className="font--grey text--md">{`A/C No - ${accountNo}, ${nameOfBank}`}</p>
          </div>
          <Button
            className={cx(
              'btn-blue-solid btn-small full-width mt10',
              styles['margin-center']
            )}
            type="blue"
            onClick={downloadForm}
            disabled={downloadingForm}
            loadingLabel={
              <Fragment>
                <Loader float="left" size="20px" inline />{' '}
                <span className="ml10"> Downloading...</span>
              </Fragment>
            }
            label="DOWNLOAD FORM"
          />
        </div>
      );
    } else if (i === 2) {
      return <Fragment>{this.getUploadButton()}</Fragment>;
    } else {
      return null;
    }
  };

  public getSubmitButton() {
    const { handleMandateAuthorize, authorizing } = this.props;
    return (
      <Button
        className={cx(
          'btn-small btn-blue-solid mt20 mb10 fr',
          styles['upload-button']
        )}
        type="orange"
        onClick={handleMandateAuthorize}
        disabled={authorizing}
        loadingLabel={
          <Fragment>
            <Loader float="left" size="20px" inline />{' '}
            <span className="ml10">Submitting...</span>
          </Fragment>
        }
        label="SUBMIT"
      />
    );
  }

  public getUploadButton() {
    const { uploadButtonClick, fileName } = this.props;
    return (
      <button
        className={cx(
          'btn-small mt20 mb10 p8',
          !fileName ? 'btn-blue-solid full-width' : 'btn btn-blue',
          styles['upload-button'],
          { fr: fileName }
          // { [styles['margin-center']]: !fileName },
          // { block: !fileName }
        )}
        onClick={uploadButtonClick}
      >
        {fileName ? 'UPLOAD AGAIN' : 'UPLOAD FORM'}
      </button>
    );
  }
  public linkRenderer(props: any) {
    return (
      <a href={props.href} rel="noopener noreferrer" target="_blank">
        {props.children}
      </a>
    );
  }

  public render() {
    const {
      children,
      fileName,
      handleUpload,
      handleBack,
      authorizing,
      fileType,
    } = this.props;
    return (
      <div className="row ml0 mr0">
        <div className="columns p0">
          {children}
          <input
            type="file"
            onChange={handleUpload}
            hidden
            accept=".png,.jpg,.jpeg,.pdf"
            id="hidden-upload-input"
          />
          <img
            id="uploaded-form"
            style={{ display: 'none' }}
            className={cx(styles['signature-sample'], 'mb20 mt20')}
          />
          {fileType === 'application/pdf' && fileName ? (
            <div className="center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z" />
              </svg>
              <span className="mt20 mb20 center font--bold ml10 verticle-align-top">
                {fileName}
              </span>
            </div>
          ) : null}
          {fileName ? (
            <div>
              <button
                className="btn btn-blue btn-small inline-block mt20 ml10 p8"
                onClick={authorizing ? null : handleBack}
              >
                BACK
              </button>
              {this.getSubmitButton()}
              {!authorizing ? this.getUploadButton() : null}
            </div>
          ) : null}
          {!fileName ? (
            <Fragment>
              <div className="large-6 columns float-right-large">
                <p className="font-grey mt10 mb30 text--normal">
                  The completed form is sent to your bank for mandate approval
                  authorisation. <br /> <br /> <strong>Please note</strong> that
                  you might be charged a one time processing fee for this
                  mandate by your bank. This is usually in the range of ₹250.
                </p>
              </div>
              <div className="large-6 columns center">
                {steps.map((step, i) => (
                  <Step {...step} key={step.title}>
                    {this.getChildren(i)}
                  </Step>
                ))}
              </div>
            </Fragment>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Nach;



// WEBPACK FOOTER //
// ./components/mandate/nach.tsx